/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { get, memoize } from 'lodash/fp';

import TableListCell from 'app/components/commons/TableListCell';
import TableListHead from 'app/components/commons/TableListHead';
import { setSortField } from 'app/actions/playerListActions';

type Props = {
  playerBoardTableInfo?: Object,
  onSort: string => void,
  showProjectedScore?: boolean,
  sortDirection?: 'asc' | 'desc',
  sortField?: string
};

const PlayerBoardTableHeadWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis6,
  color: theme.color.basis1
}));

class PlayerBoardTableHead extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    playerBoardTableInfo: undefined,
    showProjectedScore: false,
    sortDirection: undefined,
    sortField: undefined
  };

  handleSort = memoize((field: string) => () => {
    const { onSort } = this.props;

    onSort(field);
  });

  sortDirAttr = (field: string) => {
    const { sortDirection, sortField } = this.props;

    return field === sortField ? sortDirection : undefined;
  };

  render() {
    const { playerBoardTableInfo, showProjectedScore } = this.props;

    return (
      <PlayerBoardTableHeadWrapper>
        <TableListHead>
          {playerBoardTableInfo &&
            playerBoardTableInfo.columns.map(
              ({ field, hasProjectedScore = false, initial = false, label, size = 'small' }) => (
                <TableListCell
                  key={`${field}_${showProjectedScore}`}
                  initial={initial}
                  size={size}
                  onClick={this.handleSort(
                    showProjectedScore && hasProjectedScore ? `${field}Projected` : field
                  )}
                  sortDir={this.sortDirAttr(
                    showProjectedScore && hasProjectedScore ? `${field}Projected` : field
                  )}
                >
                  {label}
                </TableListCell>
              )
            )}
        </TableListHead>
      </PlayerBoardTableHeadWrapper>
    );
  }
}

const connector = connect(
  state => ({
    playerBoardTableInfo: state.challenge.playerBoardTableInfo,
    showProjectedScore: get('playerList.showProjectedScore', state),
    sortDirection: state.challenge.sortDirection,
    sortField: state.challenge.sortField
  }),
  {
    onSort: setSortField
  }
);

export default connector(PlayerBoardTableHead);
